import { Overlay, ScrollStrategy } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import {
    Component,
    ElementRef,
    HostListener,
    Input,
    QueryList,
    TemplateRef,
    ViewChildren,
    ChangeDetectionStrategy
} from '@angular/core';
import { IdGeneratorPipe } from '../../pipes/id-generator.pipe';
import { CDK_IMPORTS } from '../../shared/standalone-imports';

export interface IDropdownPanelItem {
    id: string;
    name: string;
    action?: () => void;
}

export interface IDropdownPanel {
    items: IDropdownPanelItem[];
}

@Component({
    selector: 'lib-dropdown-panel',
    templateUrl: './dropdown-panel.component.html',
    styleUrls: ['./dropdown-panel.component.scss'],
    imports: [CommonModule, IdGeneratorPipe, ...CDK_IMPORTS],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class DropdownPanelComponent {
    @ViewChildren('menuItem') menuItems!: QueryList<ElementRef>;

    protected scrollStrategy: ScrollStrategy;

    @Input()
    buttonTemplateRef!: TemplateRef<unknown>;

    @Input()
    contentTemplateRef!: TemplateRef<unknown>;

    @Input()
    textContent!: string;

    @Input()
    source: IDropdownPanel;

    @Input()
    dropdownPanelId?: string;

    opened: boolean;

    constructor(private readonly overlay: Overlay) {
        this.opened = false;
        this.source = {
            items: []
        };
        this.scrollStrategy = this.overlay.scrollStrategies.close();
    }

    openClose(event: Event) {
        event.stopPropagation();
        this.opened = !this.opened;
        if (this.opened) {
            setTimeout(() => {
                const firstItem = this.menuItems.first;
                if (firstItem) {
                    firstItem.nativeElement.focus();
                }
            }, 0);
        }
    }

    action(callback: () => void | undefined, event: Event) {
        event.stopPropagation();
        this.opened = false;
        callback();
    }

    @HostListener('document:keydown.escape')
    onEscape(): void {
        if (this.opened) {
            const activeElement = document.activeElement as HTMLElement;
            if (activeElement) {
                activeElement.blur();
            }
            this.opened = false;
        }
    }
}
